import { Box, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import useColors from "../../../../../api/hooks/useColors";

const AssetDescription = ({ formData, setFormData, disabled = false }) => {
  const colors = useColors();
  const [value, setValue] = useState("");

  useEffect(() => {
    setValue(formData.stepAssetDetails.asset.reason);
  }, [formData.stepAssetDetails.asset.reason]);

  const handleOnChange = (value) => {
    if (!value) {
      setFormData((prevData) => ({
        ...prevData,
        stepAssetDetails: {
          asset: {
            ...prevData.stepAssetDetails.asset,
            reason: "",
          },
        },
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        stepAssetDetails: {
          asset: {
            ...prevData.stepAssetDetails.asset,
            reason: value,
          },
        },
      }));
    }
  };
  return (
    <>
      <TextField
        label={
          <Box display={"flex"} flexDirection={"row"} gap={1}>
            <Typography variant="body2" color={colors.text_secondary}>
              Asset Description
            </Typography>
            <span style={{ color: colors.error_main }}>*</span>
          </Box>
        }
        placeholder="Asset Description"
        value={formData.stepAssetDetails.asset.reason}
        onChange={(event) => handleOnChange(event.target.value)}
        multiline
        rows={4}
        disabled={disabled}
        sx={{
          "& .MuiOutlinedInput-notchedOutline": {
            borderRadius: "8px",
            borderColor: colors.divider2,
          },
          "& .MuiOutlinedInput-root": {
            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
              border: "0.5px solid " + colors.divider2,
            },
            "&:hover .MuiOutlinedInput-notchedOutline": {
              border: "0.5px solid " + colors.grey_500,
            },
          },

          "& .MuiInputBase-input::placeholder": {
            color: colors.text_primary,
          },
          width: "100%",
          "& .MuiInputBase-root": { fontSize: "14px" },
        }}
      />
    </>
  );
};

export default AssetDescription;
